import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { lisTranscodesService } from 'shared/services';
import { baseCell } from 'components/cells/BaseCell';
import { AddButton } from 'components/ui';

export const LISTranscodes = () => {
  const translationPrefix = 'pages.lis-transcodes.list';
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: 'laboratory',
      headerName: t(`global.laboratory`),
      flex: 1,
      filterable: false,
      sortable: false,
      renderCell: baseCell
    },
    {
      field: 'transcode',
      headerName: t(`global.transcode`),
      flex: 1,
      filterable: false,
      sortable: false,
      renderCell: baseCell
    }
  ];

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={<AddButton to="new" prefix={translationPrefix} requireTenantAdmin />}>
      <EnhancedDataGrid columns={columns} service={lisTranscodesService} />
    </TenantPage>
  );
};

export default LISTranscodes;
